import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class PaperReqTestInfoService {
  constructor(private http: HttpClient) { }

  getInternalRequests(requestId) {
    return this.http.get(`/api/internalRequest/getRequestForDisplay`, {
      params: { requestId: requestId },
      responseType: "json"
    });
  }

  getTest() {
    return this.http.get(`/api/Test/getTest`);
  }
  getTestNameById(testId) {
    return this.http.get(`/api/Test/getTestNameById`, {
      params: { type: testId },
      responseType: "json",
      observe: "response"
    });
  }

  getTestNameByTestId(testId) {
    return this.http.get(`/api/internalTest/getTestNameById`, {
      params: { type: testId },
      responseType: "json"
    });
  }

  getTestDateName(testDateId) {
    return this.http.get(
      `/api/internaltestadministrations/getTestDateNameById`,
      {
        params: { type: testDateId },
        responseType: "json"
      }
    );
  }

  getTestDateNameById(testDateId) {
    return this.http.get(`/api/TestDate/getTestDateNameById`, {
      params: { type: testDateId },
      responseType: "json",
      observe: "response"
    });
  }
  getDates(testId) {
    return this.http.get(`/api/internalTest/getDates`, {
      params: { id: testId },
      responseType: "json",
      observe: "response"
    });
  }
  postPersonTest(data) {
    return this.http.post(`/api/InternalPersonTest/createPersonTest`, data, {
      observe: "response"
    });
  }
  updateRequest(data) {
    return this.http.put(`/api/InternalPersonTest/updateRequestForTest`, data, {
      observe: "response"
    });
  }
  updatePersonTest(data) {
    return this.http.put(`/api/InternalPersonTest/updatePersonTest`, data, {
      observe: "response"
    });
  }
  deleteAndCreateTest(data) {
    return this.http.post(`/api/InternalPersonTest/deleteAndCreateTest`, data, {
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/service/paperreqtestinfo.service.ts